import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { CartaCreateDishProdSelectPage } from '../carta-create-dish-prod-select/carta-create-dish-prod-select';
import { CartaServices } from '../../services';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the MenuCreateSelectTypePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-carta-create-select-type',
  templateUrl: 'carta-create-select-type.html',
})
export class CartaCreateSelectTypePage {

  type: any = '';
  carta_name: any = '';
  carta_name_ca: any = '';
  carta_name_en: any = '';
  carta_name_it: any = '';
  carta_name_fr: any = '';
  carta_name_de: any = '';
  carta_subtitle: any = '';
  carta_reference: any = '';
  carta_footer: any = '';
  carta_uid
  update_state: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public toastCtrl: ToastController,
    public cartaServices: CartaServices,
    public translate: TranslateService) {

    //Params
    this.update_state = this.navParams.get('update_state');
    //update
    if (this.update_state) {
      this.type = this.navParams.get('type');
      this.carta_uid = this.navParams.get('carta_uid');
      this.carta_name = this.navParams.get('carta_name');

      this.carta_name_ca = this.globals.ifVarEmpty(this.cartaServices.carta_tmp.name_ca);
      this.carta_name_en = this.globals.ifVarEmpty(this.cartaServices.carta_tmp.name_en);
      this.carta_name_it = this.globals.ifVarEmpty(this.cartaServices.carta_tmp.name_it);
      this.carta_name_fr = this.globals.ifVarEmpty(this.cartaServices.carta_tmp.name_fr);
      this.carta_name_de = this.globals.ifVarEmpty(this.cartaServices.carta_tmp.name_de);

      this.carta_subtitle = this.globals.ifVarEmpty(this.cartaServices.carta_tmp.subtitle);
      this.carta_reference = this.globals.ifVarEmpty(this.cartaServices.carta_tmp.reference);
      this.carta_footer = this.globals.ifVarEmpty(this.cartaServices.carta_tmp.footer);
    }
  }

  public addon_opened: boolean = false;

  save() {
    if (this.update_state) {
      this.update();
    } else {
      this.insert();
    }
  }

  insert() {
    //comprobar no buits
    if (this.carta_name != '' || this.carta_name_ca != '' || this.carta_name_en != '' || this.carta_name_it != '' || this.carta_name_fr != '' || this.carta_name_de != '') {
      this.cartaServices.afs.collection('cartas').add({
        UID_RESTAURANT: this.globals.restaurant_uid,
        name: this.carta_name,
        name_ca: this.carta_name_ca,
        name_en: this.carta_name_en,
        name_it: this.carta_name_it,
        name_fr: this.carta_name_fr,
        name_de: this.carta_name_de,
        subtitle: this.carta_subtitle,
        template_name: 'typhoon',
        created_at: new Date(),
        show_enumerate_elements: false,
        show_logo: true,
        show_caption: false,
        hide_footer: true,
        show_description: false,
        show_price: true,
        show_price_half: true,
        show_price_tapa: true,
        show_enumerate_pages: false,
        template: 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates%2Ffons_mct_blanc.png?alt=media&token=15455e42-1097-4eb0-bb47-1d29ef9622d5',
        digital_app: false,
      }).then(doc => {
        this.globals.GAtrackView('Cartas', 'Cartas - Select type - Create', this.globals.restaurant.email, 'Create/Update', 'Create select type', 'Cartas', doc.id);
        //push
        this.navCtrl.push(CartaCreateDishProdSelectPage, {
          type: this.type,
          carta_uid: doc.id,
          page_index: 0,
          section_index: 0,
        });
      });
    } else {
      //toast error
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-completa-datos-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }

  }

  async update() {
    //comprobar no buits
    if (this.carta_name != '' || this.carta_name_ca != '' || this.carta_name_en != '' || this.carta_name_it != '' || this.carta_name_fr != '' || this.carta_name_de != '') {
      await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
        'name': this.carta_name,
        'name_ca': this.carta_name_ca,
        'name_en': this.carta_name_en,
        'name_it': this.carta_name_it,
        'name_fr': this.carta_name_fr,
        'name_de': this.carta_name_de,
        'subtitle': this.carta_subtitle,
        'reference': this.carta_reference,
        'footer': this.carta_footer,
        'updated_at': new Date(),
      }).then(doc => {
        this.globals.GAtrackView('Cartas', 'Cartas - Select type - Update', this.globals.restaurant.email, 'Create/Update', 'Update select type', 'Cartas', this.carta_uid);
        this.navCtrl.pop();
      });
    } else {
      //toast error
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-completa-datos-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-create/carta-create-select-type/carta-create-select-type.ts